@for (step of steps(); track step; let idx = $index) {
  <div>
    <img [src]="step.imgSrc" [alt]="'Step ' + idx" />
    <h2>{{ step.heading }}</h2>
    <p>{{ step.paragraph }}</p>
  </div>
}
